import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { RequestEntity, IItemDishesForPaginationForAssign } from 'types';
import { getDishPrice } from 'utils/dishes';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import style from './Dish.module.scss';

interface IDish {
	data: IItemDishesForPaginationForAssign;
}

export const Dish: React.FC<IDish> = ({ data }) => {
	const { setIDsSelectedDishes, IDsSelectedDishes } = useContext<IDishAssignmentContext>(DishAssignmentContext);
	const isCheckedCheckbox = IDsSelectedDishes.includes(data.id);

	const containerClasses = classNames(style.container, {
		[style.hasCategories]: data.categories.length > 0,
		[style.checkedCheckbox]: isCheckedCheckbox,
	});

	const { hasManyPrices, price } = useMemo(() => getDishPrice(data), [data.portionPrices, data.price]);

	const handleChange = (value: boolean) => {
		if (value) {
			setIDsSelectedDishes([...IDsSelectedDishes, data.id]);
		} else {
			const updateDishList = IDsSelectedDishes.filter((el) => el !== data.id);
			setIDsSelectedDishes(updateDishList);
		}
	};

	return (
		<div className={containerClasses} data-test="Dish">
			<div className={style.name}>
				<Checkbox
					className={style.checkbox}
					onChange={(e) => handleChange(e.target.checked)}
					checked={isCheckedCheckbox}
				/>
				<div className={style.imgWrapper}>
					<ImgUploaderByEntityId
						resource={RequestEntity.DishesMenuV2}
						entityID={data.filePath ? data.id : ''}
						isMenuV2={true}
						photoSize="Small"
						loaderSize="small"
					/>
				</div>
				<Text className={style.dishName} translationKey={data.name} withTooltip={true} />
			</div>
			<div className={style.categories}>
				{data.categories.map((el, i) => {
					const isNeedComma = i !== data.categories.length - 1;
					return (
						<Text key={el.id} translationKey={`${el.name}${isNeedComma ? ', ' : ''}`} withTooltip={true} />
					);
				})}
			</div>
			<div className={style.subcategories}>
				{data.subCategories.map((el, i) => {
					const isNeedComma = i !== data.subCategories.length - 1;
					return (
						<Text
							key={el.id}
							translationKey={`${el.subCategoryName}${isNeedComma ? ', ' : ''}`}
							withTooltip={true}
						/>
					);
				})}
			</div>
			{data.externalId ? (
				<ChunkOfTextWithCopying className={style.externalId} text={data.externalId} />
			) : (
				<Text className={style.externalId} translationKey="-" />
			)}
			<Text
				data-test="price"
				className={style.price}
				translationNameSpace="listing"
				translationKey={hasManyPrices ? 'priceValueWithFrom' : 'priceValue'}
				translationOptions={{
					price: price !== null ? `${data.currencySymbol || ''}${price}` : '-',
				}}
				withTooltip={true}
			/>
		</div>
	);
};
